// Constantes puras (sin lógica, sin closures sobre estado) usadas por
// ListadoSolicitud.js: opciones de filtros y mapeos de id -> etiqueta/color.
// Extraídas tal cual del componente para reducir su tamaño sin tocar valores.

export const COLOR_GRAY = "#888780"; // plomo — estado sin definir
export const COLOR_NEW = "#1D9E75"; // verde
export const COLOR_FREQUENT = "#378ADD"; // azul

export const estadosOpciones = [
  { label: "Todos", value: "todos" },
  { label: "PRE-APROBADO", value: 1 },
  { label: "APROBADO", value: 2 },
  { label: "ANULADO", value: 3 },
  { label: "RECHAZADO", value: 4 },
  { label: "NO APLICA", value: 5 },
  { label: "FACTURADO", value: 6 },
  { label: "CADUCADO", value: 7 },
  { label: "NOTA DE CRÉDITO", value: 8 },
  { label: "NOTA DE CRÉDITO AUTOMATICA", value: 9 },
  { label: "RE-PROCESO", value: 10 },
];

/// estado solicitudes
export const estadoMap = {
  1: "PENDIENTE",
  10: "REVISIÓN",
  11: "CORRECIÓN",
  12: "APROBADO",
  13: "RECHAZADO",
};

export const estadoDocumentalMap = {
  1: "PROCESO",
  2: "REVISIÓN",
  3: "CORRECIÓN",
  4: "APROBACION",
};

export const estadoTelefonicaMap = {
  1: "NO ASIGNADO",
  2: "ASIGNADO",
  3: "APROBADO",
  4: "RECHAZADO",
  7: "CORRECCION"
};

// Estados de RespaldosPendientesWeb, para el filtro "Con Respaldos Pendientes"
// del listado (mismos valores que RESPALDOS_* en GestorDocumentos.js).
export const estadoRespaldosPendientesMap = {
  1: "PENDIENTE DE CARGA",
  2: "ENVIADO A REVISAR",
  3: "APROBADO",
  4: "VOLVER A CORREGIR",
  5: "RECHAZADO",
};

// Proveedor de firma electrónica de la solicitud (campo TipoFirmaElectronica).
export const TIPO_FIRMA_ELECTRONICA = {
  YUPANA: 1,
  BANCO_SOLIDARIO: 2,
};

// Estados de la solicitud (campo Estado) relevantes para habilitar la firma digital.
export const ESTADO_SOLICITUD = {
  APROBADO: 2,
  FACTURADO: 6,
};

// Estado de verificación de la solicitud (campo idEstadoVerificacionSolicitud)
// requerido para poder firmar, sin importar el proveedor.
export const ESTADO_VERIFICACION_APROBADO = 12;

export const DomicilioLaboralMap = {
  1: "ASIGNADO",
  2: "DATOS VERIFICADOR",
  3: "RECHAZA VERIFICADOR",
  4: "APROBADO ANALISTA",
  5: "RECHAZA ANALISTA",
};

export const estadoColores = {
  1: "#d0160e", // Rojo para Revisión
  2: "#f5a623", // Amarillo para Corrección
  3: "#2d3689", // Azul para Aprobado
  4: "#32CD32", // Verde para Aprobado
};
